import { IAppState } from '../types'

export const selectEmailErrorMessage = (state: IAppState): string | null =>
  state.login.emailErrorMessage

export const selectPasswordErrorMessage = (state: IAppState): string | null =>
  state.login.passwordErrorMessage
